export function movingAverage(data: [number, number][], windowSize: number) {
  const points = Array.from(data);
  return points.map((point, index) => {
    const start = Math.max(0, index - windowSize);
    const end = Math.min(points.length, index + windowSize);
    const window = points.slice(start, end);
    return [point[0], window.reduce((a, b) => a + b[1], 0) / window.length];
  });
}

export function scottMovingAverage(data: [number, number][], windowSize: number) {
  const points = Array.from(data);
  const result: [number, number][] = [];

  // Process data in chunks of 30
  for (let i = 0; i < points.length; i += windowSize) {
    const chunk = points.slice(i, Math.min(i + windowSize, points.length));
    if (chunk.length > 0) {
      // Use the latest date in the chunk
      const chunkDate = Math.max(...chunk.map((p) => p[0]));
      // Calculate average value for the chunk
      const chunkAverage = chunk.reduce((sum, p) => sum + p[1], 0) / chunk.length;

      result.push([chunkDate, chunkAverage]);
    }
  }

  return result;
}
